module.exports = __webpack_public_path__ + "static/media/mockup2.578f93cd.png";